const PINATA_URL = "https://gateway.pinata.cloud/ipfs/"
const REPORTS_URL = 'https://reports.takoe.dev/examples/'

export { PINATA_URL, REPORTS_URL }